import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { CREATE_GAS_STATION, UPDATE_GAS_STATION } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { GET_GAS_STATION } from '../../../constants/graphql/query'
import { ActionBar } from '../../../components/gas-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const [gasstation, setGasstation] = useState([])
  const [mutationVariables, setMutationVariables] = useState({})

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: id === 'creditTerm' ? parseInt(value, 10) : value,
    })
  }

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler)
          : <Query
          query={GET_GAS_STATION}
          variables={{ id: props.match.params.id }}
          fetchPolicy='cache-and-network'
        >{({
          data, error, loading,
        }) => {
          if (loading && _.isEmpty(data)) return <Loading center='true' />
          if (error) return <P>เกิดข้อผิดพลาด</P>
          onChangeHandler = (id, value) => {
            setMutationVariables({
              code: data.GasstationInfo.code,
              name: data.GasstationInfo.name,
              company: data.GasstationInfo.company,
              ...mutationVariables,
              [id]: id === 'creditTerm' ? parseInt(value, 10) : value,
            })
          }
          if (!_.isEmpty(data)) setGasstation(data.GasstationInfo)
          return (
            <Div>
              {
                detailType(props.match.params, onChangeHandler, data.GasstationInfo) // argument mode
              }
            </Div>
          )
        }}
        </Query>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode && <Mutation
        mutation={isAddMode ? CREATE_GAS_STATION : UPDATE_GAS_STATION}
      >{(doAction, resp) => (
        <ActionBar
          loading={resp.loading}
          disabled={_.isUndefined(mutationVariables.code) || _.isEmpty(mutationVariables.code)
            || _.isUndefined(mutationVariables.name) || _.isEmpty(mutationVariables.name)
            || _.isUndefined(mutationVariables.company)}
          isAddMode={isAddMode}
          isViewMode={isViewMode}
          doAction={doAction}
          mutationVariables={{ ...mutationVariables }}
          props={props}
        />
      )}
      </Mutation>
      }
      {
        isViewMode && <ActionBar
          isAddMode={isAddMode}
          isViewMode={isViewMode}
          props={props}
          gasstation={{ ...gasstation }}
        />
      }
    </Div>
  )
}

export default Index
export { Index }
